/**
 * Set entity validation rules.
 */

import { getEntityAttr, getEntityAttrString } from './ReusableValidation';
import type { ValidationWarning } from './ReusableValidation';

/**
 * Returns validation warnings for Set entity data.
 */
export function getSetWarnings(data: Record<string, any>): ValidationWarning[] {
    const warnings: ValidationWarning[] = [];

    const filterScope = getEntityAttrString(data, 'FilterScope');
    if (!filterScope) {
        warnings.push({
            message: 'Sets require a Filter Scope (entity type).',
            severity: 'warning',
            attributeDisplayNames: ['FilterScope']
        });
    }

    const typeVal = getEntityAttrString(data, 'Type').toLowerCase();

    if (typeVal === 'enumerated') {
        const filter = getEntityAttrString(data, 'Filter');
        if (!filter) {
            warnings.push({
                message: 'Enumerated sets require a filter expression.',
                severity: 'warning',
                attributeDisplayNames: ['Filter']
            });
        }
    }

    if (typeVal === 'manual' || !typeVal) {
        const members = getEntityAttr(data, 'ManualSetMember');
        const memberArr = Array.isArray(members) ? members : [];
        if (memberArr.length === 0) {
            warnings.push({
                message: 'Manual sets should have at least one member.',
                severity: 'warning',
                attributeDisplayNames: ['ManualSetMember']
            });
        }
    }

    const isSystemRaw = getEntityAttr(data, 'IsSystem');
    const isSystem = isSystemRaw === true || isSystemRaw === 'true' || isSystemRaw === 'True';
    if (isSystem) {
        warnings.push({
            message: 'This is a system-managed set. Changes may be overridden by the system.',
            severity: 'info'
        });
    }

    return warnings;
}
